export { default } from './Loyalty';